module.exports = __webpack_public_path__ + "img/eezee.2429a4ff.svg";